module.exports = __webpack_public_path__ + "static/media/medeasy-auth.80593af4.svg";